import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "../assets/css/footer.css";
import { useNavigate } from "react-router-dom";
function Footer({isAuthenticated,onLogout}) {
    const navigate = useNavigate()
  function userLogout() {
    if (window.confirm('Are you sure you want to logout?')) {
      navigate('/');
      onLogout();
    }
  }

  return (
    <footer className="footer">
      <div className="footer-grid">

        {/* COLUMN 1 — ABOUT  */}
        <div>
          <h4 className="footer-title">MVL Pharmacy</h4>

          <p className="footer-text">
            Your trusted partner for quality medicines delivered to your
            doorstep. Safe, fast and reliable care for every home.
          </p>

          <p className="footer-text">
            For urgent queries call:
            <br />
            <a href="tel:+919807200292">+91 98072 00292</a>
          </p>

          {/* Social Icons */}
          <div className="social-links" style={{ marginTop: "12px", display: "flex", gap: "10px" }}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
              <FacebookIcon sx={{ fontSize: 26 }} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <InstagramIcon sx={{ fontSize: 26 }} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
              <TwitterIcon sx={{ fontSize: 26 }} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
              <YouTubeIcon sx={{ fontSize: 26 }} />
            </a>
            <a href="https://wa.me/919807200292" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
              <WhatsAppIcon sx={{ fontSize: 26 }} />
            </a>
          </div>
        </div>

        {/* COLUMN 2 — QUICK LINKS */}
        <div>
          <h5 className="footer-subtitle">Quick Links</h5>
          <ul className="footer-links">
            <li><a href="/products">Shop</a></li>
            <li><a href="#refill">Refill Prescription</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/support">Support</a></li>
             {!isAuthenticated ? (
              <>
                <li><a href="/register">Sign Up</a></li>
                <li><a href="/login">Sign In</a></li>
              </>
            ) : (
              <li onClick={userLogout}><a href="#">Sign Out</a></li>
            )}
          </ul>
        </div>

        {/* COLUMN 3 — PRODUCTS */}
        <div>
          <h5 className="footer-subtitle">Products</h5>
          <ul className="footer-links">
            {/* DEBT-13 — five listing pages were routed in App.js with no inbound
                link from anywhere in the app, so no customer could reach them by
                clicking. That is why `/surgical` rendered an empty grid for an
                unknown length of time without anyone noticing (PERF-4): an
                unreachable page cannot report that it is broken.

                The four below with a dedicated page are now linked here. Labels
                match each page's own heading, so a link and its destination can
                no longer drift apart silently.

                Still unlinked on purpose: `/all-products`. It is an older
                duplicate of `/products` — same hook, same arguments, same 2,279
                products, only an earlier skin ("All Medicines" vs "All
                Products") — and `/products` is already linked three times, as
                "Shop" here and twice from Home. A second entry to the same
                catalogue would be a worse footer, not a more complete one. The
                page is left in place for deletion to be decided separately. */}
            <li><a href="/best-selling-products">Best Selling Products</a></li>
            <li><a href="/multivitamins-supplements">Nutraceuticals</a></li>
            <li><a href="/beauty-self-care">Beauty and Self Care</a></li>
            <li><a href="/surgical">Surgical</a></li>
            <li><a href="/categories">All Categories</a></li>
            <li><a href="/category/must-haves">Must Haves</a></li>
            <li><a href="/category/heart-care">Heart Care</a></li>
            <li><a href="/category/mother-and-baby-care">Mother and Baby Care</a></li>
            <li><a href="/category/sexual-wellness">Sexual wellness</a></li>
          </ul>
        </div>

        {/* COLUMN 4 — DELIVERY LOCATIONS */}
        <div>
          <h5 className="footer-subtitle">Delivery Locations</h5>
          <ul className="footer-links">
            <li><a href="/">Lucknow</a></li>
            <li><a href="/">Pune</a></li>
            <li><a href="/">Kanpur</a></li>
            <li><a href="/">Bhopal</a></li>
            <li><a href="/">Mumbai</a></li>
          </ul>
        </div>

        {/* COLUMN 5 — CONTACT */}
        <div>
          <h5 className="footer-subtitle">Contact</h5>
          <p className="footer-text">
            B-123, Main Market,<br />
            New Delhi, India<br />
            Mon–Sun: 8 AM — 9 PM<br />
            Email:
            <a href="mailto:info@mvlpharmacy.com"> info@mvlpharmacy.com</a>
          </p>

          <div className="footer-buttons">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <span>© 2025 MVL Pharmacy</span>
<span>Made with care <span style={{ fontSize: "18px" }}>❤️</span> • Privacy first</span>
      </div>
    </footer>
  );
}

export default Footer;
